import { api } from '../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../shared/api/genexus-query';
import type { CrudApi } from '../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../shared/components/DataTable';
import type { ClientDto, ClientInput, ClientListFilters, ClientListItem } from './types';

const BASE = '/v1/clients';

export const clientsApi: CrudApi<ClientListItem, ClientDto, ClientInput> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<ClientListItem>> {
    return listClients(query);
  },

  async get(id: number): Promise<ClientDto> {
    const { data } = await api.get<{ data: ClientDto }>(`${BASE}/${id}`);
    return data.data;
  },

  async create(input: ClientInput): Promise<ClientDto> {
    const { data } = await api.post<{ data: ClientDto }>(BASE, input);
    return data.data;
  },

  async update(id: number, input: ClientInput): Promise<ClientDto> {
    const { data } = await api.put<{ data: ClientDto }>(`${BASE}/${id}`, input);
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};

/**
 * List standalone usado pelo `ClienteSelect` quando precisa propagar filtros
 * que não cabem em `DataTableQuery` (ex.: `apontavelParaColaborador` — T-20b).
 * `clientsApi.list` reusa esta função para preservar o contrato `CrudApi`.
 */
export async function listClients(
  query: DataTableQuery,
  filters: ClientListFilters = {},
): Promise<ListEnvelope<ClientListItem>> {
  const { data } = await api.get<{
    data: ClientListItem[];
    meta: { total: number; pagina?: number; porPagina?: number };
  }>(BASE, {
    params: toGenexusParams(query, {
      apontavelParaColaborador: filters.apontavelParaColaborador ?? undefined,
    }),
  });
  return normalizeListEnvelope(data);
}
